import Request from '../utilis/request';

export function getBillings(params) {
    return Request({
        url:'/api/billings',
        method:'get',
        params:params
    })
}
export function getUserBillingInfo(params) {
    return Request({
        url:'/api/billings/user',
        method:'get',
        params:params
    })
}
export function cancelSubscription(data) {
    return Request({
        url:'/api/billings/cancel',
        method:'post',
        data:data
    })
}

export function resumeSubscription(data) {
    return Request({
        url:'/api/billings/resume',
        method:'post',
        data:data
    })
}
export function getInvoices(params) {
    return Request({
        url:'/api/billings/invoices',
        method:'get',
        params:params
    })
}
